var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { apiEndpoints } from '../../app.constants';
import { BackendHttpService } from '../../core/backend-http.service';
var ReferenceDataService = /** @class */ (function (_super) {
    __extends(ReferenceDataService, _super);
    function ReferenceDataService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReferenceDataService.prototype.loadDefinitions = function () {
        return this.get(apiEndpoints.definitions);
    };
    ReferenceDataService.prototype.updateDefinitionsData = function (definition) {
        this.definitions = definition;
    };
    Object.defineProperty(ReferenceDataService.prototype, "verticals", {
        get: function () {
            return this.definitions.verticals;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReferenceDataService.prototype, "topics", {
        get: function () {
            return this.definitions.topics;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReferenceDataService.prototype, "activeTopics", {
        get: function () {
            if (!this.definitions) {
                return [];
            }
            return this.definitions.topics.filter(function (t) { return t.isHidden === 0; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReferenceDataService.prototype, "platforms", {
        get: function () {
            return this.definitions ? this.definitions.platforms : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReferenceDataService.prototype, "countries", {
        get: function () {
            return this.definitions ? this.definitions.countries : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReferenceDataService.prototype, "languages", {
        get: function () {
            return this.definitions ? this.definitions.languages : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReferenceDataService.prototype, "network", {
        get: function () {
            return this.definitions.network;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReferenceDataService.prototype, "type", {
        get: function () {
            return this.definitions.type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReferenceDataService.prototype, "referenceData", {
        get: function () {
            return this.definitions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReferenceDataService.prototype, "channelTypes", {
        get: function () {
            return this.definitions.channelTypes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReferenceDataService.prototype, "campaignTypes", {
        get: function () {
            return this.definitions.campaignTypes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReferenceDataService.prototype, "mixPanelToken", {
        get: function () {
            return this.definitions.mixPanelToken;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReferenceDataService.prototype, "accountTypes", {
        get: function () {
            return this.definitions.accountTypes;
        },
        enumerable: true,
        configurable: true
    });
    ReferenceDataService.prototype.getLanguageByCountry = function (country) {
        return this.get(apiEndpoints.getLanguageByCountry, {
            country_id: country
        }).map(function (res) { return res.data; });
    };
    ReferenceDataService.prototype.loadDismissReasons = function () {
        return this.get(apiEndpoints.getDismissReasons).map(function (res) {
            var data = res.data;
            return data.map(function (d) { return ({
                id: d.id,
                name: d.dismissReasonsName
            }); });
        });
    };
    return ReferenceDataService;
}(BackendHttpService));
export { ReferenceDataService };



// WEBPACK FOOTER //
// ./src/app/services/reference-data/reference-data.service.ts.pre-build-optimizer.js